import { Component, DestroyRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { InvoiceManagementService } from 'src/app/services/invoicemanagement/invoicemanagement.service';
import * as moment_timezone from 'moment-timezone'
import * as moment from 'moment';
import { ViewportScroller } from '@angular/common';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { TabMenu } from 'primeng/tabmenu';
import { startWith } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const momentTz = moment_timezone;
const _moment = moment;
const dateFormat = "YYYYMMDD";

@Component({
  selector: 'app-invoicemanagementDD',
  standalone: false,
  templateUrl: './invoicemanagement-dd.component.html',
  styleUrls: ['./invoicemanagement-dd.component.scss'],
})
export class InvoicemanagementDDComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  recordStatus: string = '';
  responseId: string = '';
  @Input() selectedRecords: any;
  @Input() pageType: string ='OUT';
  @Input() selectedCountry: string = '';
  inputData: any;
  dataSourceValues: any[] = [];
  lineItemDetailsDataSource : any[] = [];
  lineItemHeaders : any = [];
  entity3Headers: any = [];
  activeState: boolean[] = [true, false, false];
  activeItem: any;
  editFlag : boolean = false;
  selectedTab : string;
  previousSelectedTab : string = '0';
  headersMultiple : any = [];
  headersCombination : any = [];
  headers1 : any;
  dataValues1 : any;
  headers2 : any;
  dataValues2 : any;
  arrayHeadersList : Array<any> = [];
  @ViewChild('tab') tab1: TabMenu;
  dummyDataSource = [
        {
          "Additional Info": {
            "label": "Additional Info",
            "value": "Multiple",
            "order": "1",
            "attributes": [
              {
                "Identifier": "",
                "Key": "",
                "Value": ""
              }
            ]
          },
          "Annotations": {
            "label": "Annotations",
            "value": "Single",
            "order": "2",
            "attributes": [
              {
                "key": "MKindicator",
                "value": "2"
              },
              {
                "key": "SBindicator",
                "value": "2"
              },
              {
                "key": "RCindicator",
                "value": "2"
              },
              {
                "key": "SPindicator",
                "value": "2"
              },
              {
                "key": "TriangularMiddlemanIndicator",
                "value": "2"
              }
            ]
          },
          "Authorized Entity": {
            "label": "Authorized Entity",
            "value": "Single",
            "order": "3",
            "attributes": [
              {
                "key": "EORInumber",
                "value": ""
              },
              {
                "key": "Identification-TaxID",
                "value": ""
              },
              {
                "key": "Identification-DifferentTaxID",
                "value": ""
              },
              {
                "key": "Identification-NoTaxIDIndicator",
                "value": ""
              },
              {
                "key": "Identification-FirstName",
                "value": ""
              },
              {
                "key": "Identification-Surname",
                "value": ""
              },
              {
                "key": "Identification-FullName",
                "value": ""
              },
              {
                "key": "Identification-TradeName",
                "value": ""
              },
              {
                "key": "PolishAddress-CountyCode",
                "value": ""
              },
              {
                "key": "PolishAddress-Voivodship",
                "value": ""
              },
              {
                "key": "PolishAddress-District",
                "value": ""
              },
              {
                "key": "PolishAddress-Municipality",
                "value": ""
              },
              {
                "key": "PolishAddress-Street",
                "value": ""
              },
              {
                "key": "PolishAddress-BuildingNumber",
                "value": ""
              },
              {
                "key": "PolishAddress-FlatNumber",
                "value": ""
              },
              {
                "key": "PolishAddress-City",
                "value": ""
              },
              {
                "key": "PolishAddress-PostalCode",
                "value": ""
              },
              {
                "key": "PolishAddress-PostOffice",
                "value": ""
              },
              {
                "key": "PolishAddress-GLN",
                "value": ""
              },
              {
                "key": "ForeignAddress-CountyCode",
                "value": ""
              },
              {
                "key": "ForeignAddress-PostalCode",
                "value": ""
              },
              {
                "key": "ForeignAddress-City",
                "value": ""
              },
              {
                "key": "ForeignAddress-Street",
                "value": ""
              },
              {
                "key": "ForeignAddress-BuildingNumber",
                "value": ""
              },
              {
                "key": "ForeignAddress-FlatNumber",
                "value": ""
              },
              {
                "key": "ForeignAddress-GLN",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-CountyCode",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-Voivodship",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-District",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-Municipality",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-Street",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-BuildingNumber",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-FlatNumber",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-City",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-PostalCode",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-Post Office",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-GLN",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-CountyCode",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-PostalCode",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-City",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-Street",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-BuildingNumber",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-FlatNumber",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-GLN",
                "value": ""
              },
              {
                "key": "Email",
                "value": ""
              },
              {
                "key": "TelephoneNumber",
                "value": ""
              },
              {
                "key": "RoleAuthorisedEntity",
                "value": ""
              }
            ]
          },
          "Bank Account": {
            "label": "Bank Account",
            "value": "Multiple",
            "order": "4",
            "attributes": [
              {
                "Identifier": "",
                "NRB": "",
                "ForeignAccountNumber": "",
                "SWIFT": "",
                "BankOwnAccount": "",
                "BankName": ""
              }
            ]
          },
          "Discount": {
            "label": "Discount",
            "value": "Single",
            "order": "5",
            "attributes": [
              {
                "key": "DiscountTerms",
                "value": ""
              },
              {
                "key": "DiscountAmount",
                "value": ""
              }
            ]
          },
          "Document Details": {
            "label": "Document Details",
            "value": "Combination",
            "order": "33",
            "HeaderAttributes": [
              {
                "key": "AmountDue",
                "value": ""
              },
              {
                "key": "AmountOverpaid",
                "value": ""
              }
            ],
            "attributes": [
              {
                "Identifier": "",
                "AmountDeducted": "",
                "DeductionReason": ""
              }
            ]
          },
          "Domestic sales - 23%": {
            "label": "Domestic sales - 23%",
            "value": "Single",
            "order": "7",
            "attributes": [
              {
                "key": "Sales23net",
                "value": "100"
              },
              {
                "key": "Sales23VATdocCurrency",
                "value": "23"
              },
              {
                "key": "Sales23VATPLN",
                "value": ""
              }
            ]
          },
          "Domestic sales - 5%": {
            "label": "Domestic sales - 5%",
            "value": "Single",
            "order": "8",
            "attributes": [
              {
                "key": "Sales5net",
                "value": ""
              },
              {
                "key": "Sales5VATdocCurrency",
                "value": ""
              },
              {
                "key": "Sales5VATPLN",
                "value": ""
              }
            ]
          },
          "Domestic sales - 8%": {
            "label": "Domestic sales - 8%",
            "value": "Single",
            "order": "9",
            "attributes": [
              {
                "key": "Sales8net",
                "value": ""
              },
              {
                "key": "Sales8VATdocCurrency",
                "value": ""
              },
              {
                "key": "Sales8VATPLN",
                "value": ""
              }
            ]
          },
          "Entity 1": {
            "label": "Entity 1",
            "value": "Single",
            "order": "10",
            "attributes": [
              {
                "key": "VATEUprefix",
                "value": "PL"
              },
              {
                "key": "EORInumber",
                "value": "125"
              },
              {
                "key": "Identification-TaxID",
                "value": "5321510339"
              },
              {
                "key": "Identification-FirstName",
                "value": ""
              },
              {
                "key": "Identification-Surname",
                "value": ""
              },
              {
                "key": "Identification-FullName",
                "value": "Podatnik1"
              },
              {
                "key": "Identification-TradeName",
                "value": ""
              },
              {
                "key": "PolishAddress-CountyCode",
                "value": "PL"
              },
              {
                "key": "PolishAddress-Voivodship",
                "value": "mazowieckie"
              },
              {
                "key": "PolishAddress-District",
                "value": "warszawa"
              },
              {
                "key": "PolishAddress-Municipality",
                "value": "warszawa"
              },
              {
                "key": "PolishAddress-Street",
                "value": "Rondo1 ONZ 1"
              },
              {
                "key": "PolishAddress-BuildingNumber",
                "value": "1"
              },
              {
                "key": "PolishAddress-FlatNumber",
                "value": "1"
              },
              {
                "key": "PolishAddress-City",
                "value": "Warszawa"
              },
              {
                "key": "PolishAddress-PostalCode",
                "value": "00-123"
              },
              {
                "key": "PolishAddress-PostOffice",
                "value": "Warszawa"
              },
              {
                "key": "PolishAddress-GLN",
                "value": ""
              },
              {
                "key": "ForeignAddress-CountyCode",
                "value": ""
              },
              {
                "key": "ForeignAddress-PostalCode",
                "value": ""
              },
              {
                "key": "ForeignAddress-City",
                "value": ""
              },
              {
                "key": "ForeignAddress-Street",
                "value": ""
              },
              {
                "key": "ForeignAddress-BuildingNumber",
                "value": ""
              },
              {
                "key": "ForeignAddress-FlatNumber",
                "value": ""
              },
              {
                "key": "ForeignAddress-GLN",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-CoutryCode",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-Voivodship",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-District",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-Municipality",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-Street",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-BuildingNumber",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-FlatNumber",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-City",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-PostalCode",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-Post Office",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-GLN",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-CoutryCode",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-PostalCode",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-City",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-Street",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-BuildingNumber",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-FlatNumber",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-GLN",
                "value": ""
              },
              {
                "key": "Email",
                "value": "Email@test.pl"
              },
              {
                "key": "TelephoneNumber",
                "value": "387659872"
              },
              {
                "key": "TaxpayerStatus",
                "value": ""
              }
            ]
          },
          "Entity 1K": {
            "label": "Entity 1K",
            "value": "Single",
            "order": "11",
            "attributes": [
              {
                "key": "VATEUprefix",
                "value": ""
              },
              {
                "key": "Identification-TaxID",
                "value": ""
              },
              {
                "key": "Identification-FirstName",
                "value": ""
              },
              {
                "key": "Identification-Surname",
                "value": ""
              },
              {
                "key": "Identification-FullName",
                "value": ""
              },
              {
                "key": "Identification-TradeName",
                "value": ""
              },
              {
                "key": "PolishAddress-CountyCode",
                "value": ""
              },
              {
                "key": "PolishAddress-Voivodship",
                "value": ""
              },
              {
                "key": "PolishAddress-District",
                "value": ""
              },
              {
                "key": "PolishAddress-Municipality",
                "value": ""
              },
              {
                "key": "PolishAddress-Street",
                "value": ""
              },
              {
                "key": "PolishAddress-BuildingNumber",
                "value": ""
              },
              {
                "key": "PolishAddress-FlatNumber",
                "value": ""
              },
              {
                "key": "PolishAddress-City",
                "value": ""
              },
              {
                "key": "PolishAddress-PostalCode",
                "value": ""
              },
              {
                "key": "PolishAddress-PostOffice",
                "value": ""
              },
              {
                "key": "PolishAddress-GLN",
                "value": ""
              },
              {
                "key": "ForeignAddress-CountyCode",
                "value": ""
              },
              {
                "key": "ForeignAddress-PostalCode",
                "value": ""
              },
              {
                "key": "ForeignAddress-City",
                "value": ""
              },
              {
                "key": "ForeignAddress-Street",
                "value": ""
              },
              {
                "key": "ForeignAddress-BuildingNumber",
                "value": ""
              },
              {
                "key": "ForeignAddress-FlatNumber",
                "value": ""
              },
              {
                "key": "ForeignAddress-GLN",
                "value": ""
              }
            ]
          },
          "Entity 2": {
            "label": "Entity 2",
            "value": "Single",
            "order": "12",
            "attributes": [
              {
                "key": "VATEUprefix",
                "value": ""
              },
              {
                "key": "EORInumber",
                "value": ""
              },
              {
                "key": "Identification-TaxID",
                "value": ""
              },
              {
                "key": "Identification-DifferentTaxID",
                "value": ""
              },
              {
                "key": "Identification-NoTaxIDIndicator",
                "value": ""
              },
              {
                "key": "Identification-FirstName",
                "value": ""
              },
              {
                "key": "Identification-Surname",
                "value": ""
              },
              {
                "key": "Identification-FullName",
                "value": ""
              },
              {
                "key": "Identification-TradeName",
                "value": ""
              },
              {
                "key": "PolishAddress-CountyCode",
                "value": ""
              },
              {
                "key": "PolishAddress-Voivodship",
                "value": ""
              },
              {
                "key": "PolishAddress-District",
                "value": ""
              },
              {
                "key": "PolishAddress-Municipality",
                "value": ""
              },
              {
                "key": "PolishAddress-Street",
                "value": ""
              },
              {
                "key": "PolishAddress-BuildingNumber",
                "value": ""
              },
              {
                "key": "PolishAddress-FlatNumber",
                "value": ""
              },
              {
                "key": "PolishAddress-City",
                "value": ""
              },
              {
                "key": "PolishAddress-PostalCode",
                "value": ""
              },
              {
                "key": "PolishAddress-PostOffice",
                "value": ""
              },
              {
                "key": "PolishAddress-GLN",
                "value": ""
              },
              {
                "key": "ForeignAddress-CountyCode",
                "value": ""
              },
              {
                "key": "ForeignAddress-PostalCode",
                "value": ""
              },
              {
                "key": "ForeignAddress-City",
                "value": ""
              },
              {
                "key": "ForeignAddress-Street",
                "value": ""
              },
              {
                "key": "ForeignAddress-BuildingNumber",
                "value": ""
              },
              {
                "key": "ForeignAddress-FlatNumber",
                "value": ""
              },
              {
                "key": "ForeignAddress-GLN",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-CountyCode",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-Voivodship",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-District",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-Municipality",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-Street",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-BuildingNumber",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-FlatNumber",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-City",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-PostalCode",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-PostOffice",
                "value": ""
              },
              {
                "key": "CorrespondencePolishAddress-GLN",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-CountyCode",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-PostalCode",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-City",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-Street",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-BuildingNumber",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-FlatNumber",
                "value": ""
              },
              {
                "key": "CorrespondenceForeignAddress-GLN",
                "value": ""
              },
              {
                "key": "Email",
                "value": ""
              },
              {
                "key": "TelephoneNumber",
                "value": ""
              },
              {
                "key": "CustomerNumber",
                "value": ""
              }
            ]
          },
          "Entity 2K": {
            "label": "Entity 2K",
            "value": "Multiple",
            "order": "13",
            "attributes": [
              {
                "Identifier": "",
                "VATEUprefix": "",
                "Identification-TaxID": "",
                "Identification-DifferentTaxID": "",
                "Identification-NoTaxIDIndicator": "",
                "Identification-FirstName": "",
                "Identification-Surname": "",
                "Identification-FullName": "",
                "Identification-TradeName": "",
                "PolishAddress-CountyCode": "",
                "PolishAddress-Voivodship": "",
                "PolishAddress-District": "",
                "PolishAddress-Municipality": "",
                "PolishAddress-Street": "",
                "PolishAddress-BuildingNumber": "",
                "PolishAddress-FlatNumber": "",
                "PolishAddress-City": "",
                "PolishAddress-PostalCode": "",
                "PolishAddress-PostOffice": "",
                "PolishAddress-GLN": "",
                "ForeignAddress-CountyCode": "",
                "ForeignAddress-PostalCode": "",
                "ForeignAddress-City": "",
                "ForeignAddress-Street": "",
                "ForeignAddress-BuildingNumber": "",
                "ForeignAddress-FlatNumber": "",
                "ForeignAddress-GLN": ""
              }
            ]
          },
          "Entity 3": {
            "label": "Entity 3",
            "value": "Multiple",
            "order": "14",
            "attributes": [
              {
                "Identifier": "",
                "EORInumber": "",
                "Identification-TaxID": "",
                "Identification-DifferentTaxID": "",
                "Identification-NoTaxIDIndicator": "",
                "Identification-FirstName": "",
                "Identification-Surname": "",
                "Identification-FullName": "",
                "Identification-TradeName": "",
                "PolishAddress-CountyCode": "",
                "PolishAddress-Voivodship": "",
                "PolishAddress-District": "",
                "PolishAddress-Municipality": "",
                "PolishAddress-Street": "",
                "PolishAddress-BuildingNumber": "",
                "PolishAddress-FlatNumber": "",
                "PolishAddress-City": "",
                "PolishAddress-PostalCode": "",
                "PolishAddress-Post Office": "",
                "PolishAddress-GLN": "",
                "ForeignAddress-CountyCode": "",
                "ForeignAddress-PostalCode": "",
                "ForeignAddress-City": "",
                "ForeignAddress-Street": "",
                "ForeignAddress-BuildingNumber": "",
                "ForeignAddress-FlatNumber": "",
                "ForeignAddress-GLN": "",
                "CorrespondencePolishAddress-CountyCode": "",
                "CorrespondencePolishAddress-Voivodship": "",
                "CorrespondencePolishAddress-District": "",
                "CorrespondencePolishAddress-Municipality": "",
                "CorrespondencePolishAddress-Street": "",
                "CorrespondencePolishAddress-BuildingNumber": "",
                "CorrespondencePolishAddress-FlatNumber": "",
                "CorrespondencePolishAddress-City": "",
                "CorrespondencePolishAddress-PostalCode": "",
                "CorrespondencePolishAddress-Poczta": "",
                "CorrespondencePolishAddress-GLN": "",
                "CorrespondenceForeignAddress-CountyCode": "",
                "CorrespondenceForeignAddress-PostalCode": "",
                "CorrespondenceForeignAddress-City": "",
                "CorrespondenceForeignAddress-Street": "",
                "CorrespondenceForeignAddress-BuildingNumber": "",
                "CorrespondenceForeignAddress-FlatNumber": "",
                "CorrespondenceForeignAddress-GLN": "",
                "Email": "",
                "TelephoneNumber": "",
                "RoleEntity": "",
                "OtherRoleIndicator": "",
                "RoleDescription": "",
                "SharePercentage": "",
                "CustomerNumber": ""
              }
            ]
          },
          "Factor Bank Account": {
            "label": "Factor Bank Account",
            "value": "Multiple",
            "order": "15",
            "attributes": [
              {
                "Identifier": "",
                "NRB": "",
                "ForeignAccountNumber": "",
                "SWIFT": "",
                "BankOwnAccount": "",
                "BankName": ""
              }
            ]
          },
          "General": {
            "label": "General",
            "value": "Single",
            "order": "16",
            "attributes": [
              {
                "key": "Header-SystemInfo",
                "value": "ERROR_NO_OBLIGATORY_NODE"
              }
            ]
          },
          "Invoice Line": {
            "label": "Invoice Line",
            "value": "Multiple",
            "order": "17"
          },
          "Invoice period": {
            "label": "Invoice period",
            "value": "Single",
            "order": "18",
            "attributes": [
              {
                "key": "DateFrom",
                "value": ""
              },
              {
                "key": "DateTo",
                "value": ""
              }
            ]
          },
          "New means of transport": {
            "label": "New means of transport",
            "value": "Single",
            "order": "19",
            "attributes": [
              {
                "key": "Indicator",
                "value": "2"
              },
              {
                "key": "DateApproval",
                "value": ""
              },
              {
                "key": "Brand",
                "value": ""
              },
              {
                "key": "Model",
                "value": ""
              },
              {
                "key": "Color",
                "value": ""
              },
              {
                "key": "RegistrationNumber",
                "value": ""
              },
              {
                "key": "ProductionNumber",
                "value": ""
              },
              {
                "key": "Mileage",
                "value": ""
              },
              {
                "key": "VIN",
                "value": ""
              },
              {
                "key": "CarBodyNumber",
                "value": ""
              },
              {
                "key": "CarChassisNumber",
                "value": ""
              },
              {
                "key": "CarFrameNumber",
                "value": ""
              },
              {
                "key": "TypeMeansOfTransport",
                "value": ""
              },
              {
                "key": "ShipWorkingHours",
                "value": ""
              },
              {
                "key": "ShipHullNumber",
                "value": ""
              },
              {
                "key": "AircraftWorkingHours",
                "value": ""
              },
              {
                "key": "AircraftSerialNumber",
                "value": ""
              }
            ]
          },
          "Order Line": {
            "label": "Order Line",
            "value": "Multiple",
            "order": "20"
          },
          "Partial Payment": {
            "label": "Partial Payment",
            "value": "Multiple",
            "order": "21",
            "attributes": [
              {
                "Identifier": "",
                "Amount": "",
                "Date": ""
              }
            ]
          },
          "Payment": {
            "label": "Payment",
            "value": "Single",
            "order": "22",
            "attributes": [
              {
                "key": "PaidInvoiceIndicator",
                "value": ""
              },
              {
                "key": "DatePayment",
                "value": ""
              },
              {
                "key": "PartialPaymentIndicator",
                "value": ""
              },
              {
                "key": "PaymentMethod",
                "value": ""
              },
              {
                "key": "OtherPaymentIndicator",
                "value": ""
              },
              {
                "key": "OtherPaymentDescription",
                "value": ""
              }
            ]
          },
          "Payment Terms": {
            "label": "Payment Terms",
            "value": "Multiple",
            "order": "23",
            "attributes": [
              {
                "Identifier": "",
                "PaymentDeadline": "",
                "PaymentDeadlineDescription": ""
              }
            ]
          },
          "Transaction Conditions": {
            "label": "Transaction Conditions",
            "value": "Single",
            "order": "24",
            "attributes": [
              {
                "key": "IntermediaryIndicator",
                "value": ""
              },
              {
                "key": "Incoterms",
                "value": ""
              },
              {
                "key": "ExchangeRateContract",
                "value": ""
              },
              {
                "key": "CurrencyCodeContract",
                "value": ""
              }
            ]
          },
          "Transaction Conditions-Agreements": {
            "label": "Transaction Conditions-Agreements",
            "value": "Multiple",
            "order": "25",
            "attributes": [
              {
                "Identifier": "",
                "Date": "",
                "Number": ""
              }
            ]
          },
          "Transaction Conditions-Orders": {
            "label": "Transaction Conditions-Orders",
            "value": "Multiple",
            "order": "26",
            "attributes": [
              {
                "Identifier": "",
                "DateOrder": "",
                "OrderNumber": ""
              }
            ]
          },
          "Transportation Details": {
            "label": "Transportation Details",
            "value": "Multiple",
            "order": "27",
            "attributes": [
              {
                "Transport-TransactionConditions-Identifier": "",
                "TransportType": "",
                "OtherTransportIndicator": "",
                "OtherTransportDescription": "",
                "CarrierIdentification-TaxID": "",
                "CarrierIdentification-DifferentTaxID": "",
                "CarrierIdentification-NoTaxIDIndicator": "",
                "CarrierIdentification-FirstName": "",
                "CarrierIdentification-Surname": "",
                "CarrierIdentification-FullName": "",
                "CarrierIdentification-TradeName": "",
                "CarrierPolishAddress-CountyCode": "",
                "CarrierPolishAddress-Voivodship": "",
                "CarrierPolishAddress-District": "",
                "CarrierPolishAddress-Municipality": "",
                "CarrierPolishAddress-Street": "",
                "CarrierPolishAddress-BuildingNumber": "",
                "CarrierPolishAddress-FlatNumber": "",
                "CarrierPolishAddress-City": "",
                "CarrierPolishAddress-PostalCode": "",
                "CarrierPolishAddress-PostOffice": "",
                "CarrierPolishAddress-GLN": "",
                "CarrierForeignAddress-CountyCode": "",
                "CarrierForeignAddress-PostalCode": "",
                "CarrierForeignAddress-City": "",
                "CarrierForeignAddress-Street": "",
                "CarrierForeignAddress-BuildingNumber": "",
                "CarrierForeignAddress-FlatNumber": "",
                "CarrierForeignAddress-GLN": "",
                "TransportOrderNumber": "",
                "CargoType": "",
                "OtherCargoIndicator": "",
                "OtherCargoDescrpition": "",
                "PackagingUnit": "",
                "TransportStartDateTime": "",
                "TransportEndDateTime": "",
                "ShippingFromPolishAddress-CountyCode": "",
                "ShippingFromPolishAddress-Voivodship": "",
                "ShippingFromPolishAddress-District": "",
                "ShippingFromPolishAddress-Municipality": "",
                "ShippingFromPolishAddress-Street": "",
                "ShippingFromPolishAddress-BuildingNumber": "",
                "ShippingFromPolishAddress-FlatNumber": "",
                "ShippingFromPolishAddress-City": "",
                "ShippingFromPolishAddress-PostalCode": "",
                "ShippingFromPolishAddress-Post Office": "",
                "ShippingFromPolishAddress-GLN": "",
                "ShippingFromForeignAddress-CountyCode": "",
                "ShippingFromForeignAddress-PostalCode": "",
                "ShippingFromForeignAddress-City": "",
                "ShippingFromForeignAddress-Street": "",
                "ShippingFromForeignAddress-BuildingNumber": "",
                "ShippingFromForeignAddress-FlatNumber": "",
                "ShippingFromForeignAddress-GLN": "",
                "Transport-ShippingVia-Identifier": "",
                "ShippingViaPolishAddress-CountyCode": "",
                "ShippingViaPolishAddress-Voivodship": "",
                "ShippingViaPolishAddress-District": "",
                "ShippingViaPolishAddress-Municipality": "",
                "ShippingViaPolishAddress-Street": "",
                "ShippingViaPolishAddress-BuildingNumber": "",
                "ShippingViaPolishAddress-FlatNumber": "",
                "ShippingViaPolishAddress-City": "",
                "ShippingViaPolishAddress-PostalCode": "",
                "ShippingViaPolishAddress-PostOffice": "",
                "ShippingViaPolishAddress-GLN": "",
                "ShippingViaForeignAddress-CountyCode": "",
                "ShippingViaForeignAddress-PostalCode": "",
                "ShippingViaForeignAddress-City": "",
                "ShippingViaForeignAddress-Street": "",
                "ShippingViaForeignAddress-BuildingNumber": "",
                "ShippingViaForeignAddress-FlatNumber": "",
                "ShippingViaForeignAddress-GLN": "",
                "ShippingToPolishAddress-CountyCode": "",
                "ShippingToPolishAddress-Voivodship": "",
                "ShippingToPolishAddress-District": "",
                "ShippingToPolishAddress-Municipality": "",
                "ShippingToPolishAddress-Street": "",
                "ShippingToPolishAddress-BuildingNumber": "",
                "ShippingToPolishAddress-FlatNumber": "",
                "ShippingToPolishAddress-City": "",
                "ShippingToPolishAddress-PostalCode": "",
                "ShippingToPolishAddress-Post Office": "",
                "ShippingToPolishAddress-GLN": "",
                "ShippingToForeignAddress-CountyCode": "",
                "ShippingToForeignAddress-PostalCode": "",
                "ShippingToForeignAddress-City": "",
                "ShippingToForeignAddress-Street": "",
                "ShippingToForeignAddress-BuildingNumber": "",
                "ShippingToForeignAddress-FlatNumber": "",
                "ShippingToForeignAddress-GLN": ""
              }
            ]
          },
          "VAT exemption": {
            "label": "VAT exemption",
            "value": "Single",
            "order": "28",
            "attributes": [
              {
                "key": "ZWindicator",
                "value": "2"
              },
              {
                "key": "LegalBasisVAT",
                "value": ""
              },
              {
                "key": "LegalBasisEU",
                "value": ""
              },
              {
                "key": "LegalBasisOther",
                "value": ""
              }
            ]
          },
          "VAT margin": {
            "label": "VAT margin",
            "value": "Single",
            "order": "29",
            "attributes": [
              {
                "key": "MarginProcedureindicator",
                "value": ""
              },
              {
                "key": "MarginTouristindicator",
                "value": ""
              },
              {
                "key": "MarginUsedWaresindicator",
                "value": ""
              },
              {
                "key": "MarginArtindicator",
                "value": ""
              },
              {
                "key": "MarginCollectorsindicator",
                "value": ""
              }
            ]
          },
          "Correction": {
            "label": "Correction",
            "value": "Combination",
            "order": "30",
            "HeaderAttributes": [
              {
                "key": "CorrectionReason",
                "value": ""
              },
              {
                "key": "CorrectionEffect",
                "value": ""
              },
              {
                "key": "CorrectionPeriod",
                "value": ""
              },
              {
                "key": "DocNumberCorrectOriginalInvoice",
                "value": ""
              }
            ],
            "attributes": [
              {}
            ]
          },
          "Debits": {
            "label": "Debits",
            "value": "Combination",
            "order": "31",
            "HeaderAttributes": [
              {
                "key": "ChargesSum",
                "value": ""
              }
            ],
            "attributes": [
              {
                "Identifier": "",
                "AmountAdded": "",
                "AdditionReason": ""
              }
            ]
          },
          "Deductions": {
            "label": "Deductions",
            "value": "Combination",
            "order": "32",
            "HeaderAttributes": [
              {
                "key": "Sum",
                "value": ""
              }
            ],
            "attributes": [
              {
                "Identifier": "",
                "AmountDeducted": "",
                "DeductionReason": ""
              }
            ]
          },
          "Footer": {
            "label": "Footer",
            "value": "Combination",
            "order": "34",
            "HeaderAttributes": [
              {}
            ],
            "attributes": [
              {
                "Register-Identifier": "",
                "Register-Full Name": "",
                "Register-KRSnumber": "",
                "Register-REGONnumber": "",
                "Register-BDOnumber": ""
              }
            ]
          }
        }
  ]
          
 
  data1 = [
    [
      {
          "key": "Identifier",
          "value": "1"
      },
      {
          "key": "EORInumber",
          "value": "dummy0"
      },
      {
          "key": "Identification-TaxID",
          "value": "dummy1"
      },
      {
          "key": "Identification-DifferentTaxID",
          "value": "dummy2"
      },
      {
          "key": "Identification-NoTaxIDIndicator",
          "value": "dummy3"
      },
      {
          "key": "Identification-FirstName",
          "value": "dummy4"
      },
      {
          "key": "Identification-Surname",
          "value": "dummy5"
      },
      {
          "key": "Identification-FullName",
          "value": "dummy6"
      },
      {
          "key": "Identification-TradeName",
          "value": "dummy7"
      },
      {
          "key": "PolishAddress-CountyCode",
          "value": "dummy8"
      },
      {
          "key": "PolishAddress-Voivodship",
          "value": "dummy9"
      },
      {
          "key": "PolishAddress-District",
          "value": "dummy10"
      },
      {
          "key": "PolishAddress-Municipality",
          "value": "dummy11"
      },
      {
          "key": "PolishAddress-Street",
          "value": "dummy12"
      },
      {
          "key": "PolishAddress-BuildingNumber",
          "value": "dummy13"
      },
      {
          "key": "PolishAddress-FlatNumber",
          "value": "dummy14"
      },
      {
          "key": "PolishAddress-City",
          "value": "dummy15"
      },
      {
          "key": "PolishAddress-PostalCode",
          "value": "dummy16"
      },
      {
          "key": "PolishAddress-Post Office",
          "value": "dummy17"
      },
      {
          "key": "PolishAddress-GLN",
          "value": "dummy18"
      },
      {
          "key": "ForeignAddress-CountyCode",
          "value": "dummy19"
      },
      {
          "key": "ForeignAddress-PostalCode",
          "value": "dummy20"
      },
      {
          "key": "ForeignAddress-City",
          "value": "dummy21"
      },
      {
          "key": "ForeignAddress-Street",
          "value": "dummy22"
      },
      {
          "key": "ForeignAddress-BuildingNumber",
          "value": "dummy23"
      },
      {
          "key": "ForeignAddress-FlatNumber",
          "value": "dummy24"
      },
      {
          "key": "ForeignAddress-GLN",
          "value": "dummy25"
      },
      {
          "key": "CorrespondencePolishAddress-CountyCode",
          "value": "dummy26"
      },
      {
          "key": "CorrespondencePolishAddress-Voivodship",
          "value": "dummy27"
      },
      {
          "key": "CorrespondencePolishAddress-District",
          "value": "dummy28"
      },
      {
          "key": "CorrespondencePolishAddress-Municipality",
          "value": "dummy29"
      },
      {
          "key": "CorrespondencePolishAddress-Street",
          "value": "dummy30"
      },
      {
          "key": "CorrespondencePolishAddress-BuildingNumber",
          "value": "dummy31"
      },
      {
          "key": "CorrespondencePolishAddress-FlatNumber",
          "value": "dummy32"
      },
      {
          "key": "CorrespondencePolishAddress-City",
          "value": "dummy33"
      },
      {
          "key": "CorrespondencePolishAddress-PostalCode",
          "value": "dummy34"
      },
      {
          "key": "CorrespondencePolishAddress-Poczta",
          "value": "dummy35"
      },
      {
          "key": "CorrespondencePolishAddress-GLN",
          "value": "dummy36"
      },
      {
          "key": "CorrespondenceForeignAddress-CountyCode",
          "value": "dummy37"
      },
      {
          "key": "CorrespondenceForeignAddress-PostalCode",
          "value": "dummy38"
      },
      {
          "key": "CorrespondenceForeignAddress-City",
          "value": "dummy39"
      },
      {
          "key": "CorrespondenceForeignAddress-Street",
          "value": "dummy40"
      },
      {
          "key": "CorrespondenceForeignAddress-BuildingNumber",
          "value": "dummy41"
      },
      {
          "key": "CorrespondenceForeignAddress-FlatNumber",
          "value": "dummy42"
      },
      {
          "key": "CorrespondenceForeignAddress-GLN",
          "value": "dummy43"
      },
      {
          "key": "Email",
          "value": "dummy44"
      },
      {
          "key": "TelephoneNumber",
          "value": "dummy45"
      },
      {
          "key": "RoleEntity",
          "value": "dummy46"
      },
      {
          "key": "OtherRoleIndicator",
          "value": "dummy47"
      },
      {
          "key": "RoleDescription",
          "value": "dummy48"
      },
      {
          "key": "SharePercentage",
          "value": "dummy49"
      },
      {
          "key": "CustomerNumber",
          "value": "dummy50"
      }
  ],
  [
    {
        "key": "Identifier",
        "value": "2"
    },
    {
        "key": "EORInumber",
        "value": "second0"
    },
    {
        "key": "Identification-TaxID",
        "value": "second1"
    },
    {
        "key": "Identification-DifferentTaxID",
        "value": "second2"
    },
    {
        "key": "Identification-NoTaxIDIndicator",
        "value": "second3"
    },
    {
        "key": "Identification-FirstName",
        "value": "second4"
    },
    {
        "key": "Identification-Surname",
        "value": "second5"
    },
    {
        "key": "Identification-FullName",
        "value": "second6"
    },
    {
        "key": "Identification-TradeName",
        "value": "second7"
    },
    {
        "key": "PolishAddress-CountyCode",
        "value": "second8"
    },
    {
        "key": "PolishAddress-Voivodship",
        "value": "second9"
    },
    {
        "key": "PolishAddress-District",
        "value": "second10"
    },
    {
        "key": "PolishAddress-Municipality",
        "value": "second11"
    },
    {
        "key": "PolishAddress-Street",
        "value": "second12"
    },
    {
        "key": "PolishAddress-BuildingNumber",
        "value": "second13"
    },
    {
        "key": "PolishAddress-FlatNumber",
        "value": "second14"
    },
    {
        "key": "PolishAddress-City",
        "value": "second15"
    },
    {
        "key": "PolishAddress-PostalCode",
        "value": "second16"
    },
    {
        "key": "PolishAddress-Post Office",
        "value": "second17"
    },
    {
        "key": "PolishAddress-GLN",
        "value": "second18"
    },
    {
        "key": "ForeignAddress-CountyCode",
        "value": "second19"
    },
    {
        "key": "ForeignAddress-PostalCode",
        "value": "second20"
    },
    {
        "key": "ForeignAddress-City",
        "value": "second21"
    },
    {
        "key": "ForeignAddress-Street",
        "value": "second22"
    },
    {
        "key": "ForeignAddress-BuildingNumber",
        "value": "second23"
    },
    {
        "key": "ForeignAddress-FlatNumber",
        "value": "second24"
    },
    {
        "key": "ForeignAddress-GLN",
        "value": "second25"
    },
    {
        "key": "CorrespondencePolishAddress-CountyCode",
        "value": "second26"
    },
    {
        "key": "CorrespondencePolishAddress-Voivodship",
        "value": "second27"
    },
    {
        "key": "CorrespondencePolishAddress-District",
        "value": "second28"
    },
    {
        "key": "CorrespondencePolishAddress-Municipality",
        "value": "second29"
    },
    {
        "key": "CorrespondencePolishAddress-Street",
        "value": "second30"
    },
    {
        "key": "CorrespondencePolishAddress-BuildingNumber",
        "value": "second31"
    },
    {
        "key": "CorrespondencePolishAddress-FlatNumber",
        "value": "second32"
    },
    {
        "key": "CorrespondencePolishAddress-City",
        "value": "second33"
    },
    {
        "key": "CorrespondencePolishAddress-PostalCode",
        "value": "second34"
    },
    {
        "key": "CorrespondencePolishAddress-Poczta",
        "value": "second35"
    },
    {
        "key": "CorrespondencePolishAddress-GLN",
        "value": "second36"
    },
    {
        "key": "CorrespondenceForeignAddress-CountyCode",
        "value": "second37"
    },
    {
        "key": "CorrespondenceForeignAddress-PostalCode",
        "value": "second38"
    },
    {
        "key": "CorrespondenceForeignAddress-City",
        "value": "second39"
    },
    {
        "key": "CorrespondenceForeignAddress-Street",
        "value": "second40"
    },
    {
        "key": "CorrespondenceForeignAddress-BuildingNumber",
        "value": "second41"
    },
    {
        "key": "CorrespondenceForeignAddress-FlatNumber",
        "value": "second42"
    },
    {
        "key": "CorrespondenceForeignAddress-GLN",
        "value": "second43"
    },
    {
        "key": "Email",
        "value": "second44"
    },
    {
        "key": "TelephoneNumber",
        "value": "second45"
    },
    {
        "key": "RoleEntity",
        "value": "second46"
    },
    {
        "key": "OtherRoleIndicator",
        "value": "second47"
    },
    {
        "key": "RoleDescription",
        "value": "second48"
    },
    {
        "key": "SharePercentage",
        "value": "second49"
    },
    {
        "key": "CustomerNumber",
        "value": "second50"
    }
]
  ]
  entity3Attributes= [
    {
        "key": "Identifier",
        "value": "1"
    },
    {
        "key": "EORInumber",
        "value": "dummy0"
    },
    {
        "key": "Identification-TaxID",
        "value": "dummy1"
    },
    {
        "key": "Identification-DifferentTaxID",
        "value": "dummy2"
    },
    {
        "key": "Identification-NoTaxIDIndicator",
        "value": "dummy3"
    },
    {
        "key": "Identification-FirstName",
        "value": "dummy4"
    },
    {
        "key": "Identification-Surname",
        "value": "dummy5"
    },
    {
        "key": "Identification-FullName",
        "value": "dummy6"
    },
    {
        "key": "Identification-TradeName",
        "value": "dummy7"
    },
    {
        "key": "PolishAddress-CountyCode",
        "value": "dummy8"
    },
    {
        "key": "PolishAddress-Voivodship",
        "value": "dummy9"
    },
    {
        "key": "PolishAddress-District",
        "value": "dummy10"
    },
    {
        "key": "PolishAddress-Municipality",
        "value": "dummy11"
    },
    {
        "key": "PolishAddress-Street",
        "value": "dummy12"
    },
    {
        "key": "PolishAddress-BuildingNumber",
        "value": "dummy13"
    },
    {
        "key": "PolishAddress-FlatNumber",
        "value": "dummy14"
    },
    {
        "key": "PolishAddress-City",
        "value": "dummy15"
    },
    {
        "key": "PolishAddress-PostalCode",
        "value": "dummy16"
    },
    {
        "key": "PolishAddress-Post Office",
        "value": "dummy17"
    },
    {
        "key": "PolishAddress-GLN",
        "value": "dummy18"
    },
    {
        "key": "ForeignAddress-CountyCode",
        "value": "dummy19"
    },
    {
        "key": "ForeignAddress-PostalCode",
        "value": "dummy20"
    },
    {
        "key": "ForeignAddress-City",
        "value": "dummy21"
    },
    {
        "key": "ForeignAddress-Street",
        "value": "dummy22"
    },
    {
        "key": "ForeignAddress-BuildingNumber",
        "value": "dummy23"
    },
    {
        "key": "ForeignAddress-FlatNumber",
        "value": "dummy24"
    },
    {
        "key": "ForeignAddress-GLN",
        "value": "dummy25"
    },
    {
        "key": "CorrespondencePolishAddress-CountyCode",
        "value": "dummy26"
    },
    {
        "key": "CorrespondencePolishAddress-Voivodship",
        "value": "dummy27"
    },
    {
        "key": "CorrespondencePolishAddress-District",
        "value": "dummy28"
    },
    {
        "key": "CorrespondencePolishAddress-Municipality",
        "value": "dummy29"
    },
    {
        "key": "CorrespondencePolishAddress-Street",
        "value": "dummy30"
    },
    {
        "key": "CorrespondencePolishAddress-BuildingNumber",
        "value": "dummy31"
    },
    {
        "key": "CorrespondencePolishAddress-FlatNumber",
        "value": "dummy32"
    },
    {
        "key": "CorrespondencePolishAddress-City",
        "value": "dummy33"
    },
    {
        "key": "CorrespondencePolishAddress-PostalCode",
        "value": "dummy34"
    },
    {
        "key": "CorrespondencePolishAddress-Poczta",
        "value": "dummy35"
    },
    {
        "key": "CorrespondencePolishAddress-GLN",
        "value": "dummy36"
    },
    {
        "key": "CorrespondenceForeignAddress-CountyCode",
        "value": "dummy37"
    },
    {
        "key": "CorrespondenceForeignAddress-PostalCode",
        "value": "dummy38"
    },
    {
        "key": "CorrespondenceForeignAddress-City",
        "value": "dummy39"
    },
    {
        "key": "CorrespondenceForeignAddress-Street",
        "value": "dummy40"
    },
    {
        "key": "CorrespondenceForeignAddress-BuildingNumber",
        "value": "dummy41"
    },
    {
        "key": "CorrespondenceForeignAddress-FlatNumber",
        "value": "dummy42"
    },
    {
        "key": "CorrespondenceForeignAddress-GLN",
        "value": "dummy43"
    },
    {
        "key": "Email",
        "value": "dummy44"
    },
    {
        "key": "TelephoneNumber",
        "value": "dummy45"
    },
    {
        "key": "RoleEntity",
        "value": "dummy46"
    },
    {
        "key": "OtherRoleIndicator",
        "value": "dummy47"
    },
    {
        "key": "RoleDescription",
        "value": "dummy48"
    },
    {
        "key": "SharePercentage",
        "value": "dummy49"
    },
    {
        "key": "CustomerNumber",
        "value": "dummy50"
    }
]
  data=[]
  Suppliertabs=[
   {
      attributes: [
        {
          key: '',
          value: ''
        }
      ]
   }
  ]
  activeItem2
  items = [
      {label: 'Header details',
      command: () => {
        this.activeItem = this.items[0];
      }
    },
      {label: 'Line Item details',
      command: () => {
        this.activeItem = this.items[1];
      }}
  ];
  activeLabel
  language: string;
  lang: string;
  selLang: string;
  count: number = 0;
  currentDashLang: string;

  constructor(
    private invoiceManagementService: InvoiceManagementService,
    private viewportScroller: ViewportScroller,
    private translate: TranslateService) {

  }

  ngOnInit(): void {
    
    this.lineItemHeaders = [
      { field: 'InvoiceLineNumber', value: 'Item-InvoiceLineNumber' },
      { field: 'UU_ID', value: 'Item-UU_ID' },
      { field: 'SaleDate', value: 'Item-SaleDate' },
      { field: 'GoodName', value: 'Item-GoodName' },
      { field: 'GTIN', value: 'Item-GTIN' },
      { field: 'PKWiUcode', value: 'Item-PKWiUcode' },
      { field: 'CNcode', value: 'Item-CNcode' },
      { field: 'PKOBcode', value: 'Item-PKOBcode' },
      { field: 'AdditionalInfo', value: 'Item-AdditionalInfo' },
      { field: 'Measure', value: 'measure' },
      { field: 'Quantity', value: 'quantity' },
      { field: 'UnitPriceNet', value: 'unitPriceNet' },
      { field: 'UnitPriceGross', value: 'unitPriceGross' },
      { field: 'Rebate', value: 'rebate' },
      { field: 'SalesValueNet', value: 'salesValueNet' },
      { field: 'SalesValueGross', value: 'salesValueGross' },
      { field: 'TaxRate', value: 'txRt' },
      { field: 'TaxRateSW', value: 'txRtSw' },
      { field: 'P_12Indicator', value: 'indicator' },
      { field: 'ExciseDutyIncluded', value: 'exciseDutyIncluded' },
      { field: 'GTUmarking', value: 'gtMarking' },
      { field: 'ProceduralMarking', value: 'procMarking' },
      { field: 'ExchangeRate', value: 'ExchaneRt' },
      { field: 'GLCode1', value: 'glcode1' },
      { field: 'ProductCodeLine', value: 'prdCodeLine' },
      { field: 'UserDefinedColumn1', value: 'udf1' },
      { field: 'UserDefinedColumn2', value: 'udf2' },
      { field: 'UserDefinedColumn3', value: 'udf3' },
      { field: 'UserDefinedColumn4', value: 'udf4' },
      { field: 'UserDefinedColumn5', value: 'udf5' },
      { field: 'UserDefinedColumn6', value: 'udf6' },
      { field: 'UserDefinedColumn7', value: 'udf7' },
      { field: 'UserDefinedColumn8', value: 'udf8' },
      { field: 'UserDefinedColumn9', value: 'udf9' },
      { field: 'UserDefinedColumn10', value: 'udf10' }
    ];

    this.entity3Headers = [
      { field: 'Identifier', value: 'recordStatus' },
      { field: 'EORInumber', value: 'kseFNumber' },
      { field: 'TaxID', value: 'systemInfo' },
      { field: 'DifferentTaxID', value: 'sellerFullName' },
      { field: 'NoTaxIDIndicator', value: 'sellerVATEUPrefix' },
      { field: 'FirstName', value: 'sellerTaxID' },
      { field: 'Surname', value: 'buyerFullName' },
      { field: 'FullName', value: 'buyerVATEUPrefix' },
      { field: 'TradeName', value: 'buyerTaxID' },
      { field: 'Address-CountyCode', value: 'invoiceNumber' },
      { field: 'Address-Voivodship', value: 'documentCurrency' },
      { field: 'Address-District', value: 'documentDate' },
      { field: 'Address-Municipality', value: 'saleDate' },
      { field: 'Address-Street', value: 'net23taxRate' },
      { field: 'Address-BuildingNumber', value: 'vat23taxRate' },
      { field: 'Address-FlatNumber', value: 'net8taxRate' },
      { field: 'Address-City', value: 'vat8taxRate' },
      { field: 'Address-PostalCode', value: 'gross' },
      { field: 'Address-Post Office', value: 'invoiceType' },
      { field: 'Address-GLN', value: 'recordStatus' },
      { field: 'ForeignAddress-CountyCode', value: 'kseFNumber' },
      { field: 'ForeignAddress-PostalCode', value: 'systemInfo' },
      { field: 'ForeignAddress-City', value: 'sellerFullName' },
      { field: 'ForeignAddress-Street', value: 'sellerVATEUPrefix' },
      { field: 'ForeignAddress-BuildingNumber', value: 'sellerTaxID' },
      { field: 'ForeignAddress-FlatNumber', value: 'buyerFullName' },
      { field: 'ForeignAddress-GLN', value: 'buyerVATEUPrefix' },
      { field: 'CorrespondenceAddress-CountyCode', value: 'buyerTaxID' },
      { field: 'CorrespondenceAddress-Voivodship', value: 'invoiceNumber' },
      { field: 'CorrespondenceAddress-District', value: 'documentCurrency' },
      { field: 'CorrespondenceAddress-Municipality', value: 'documentDate' },
      { field: 'CorrespondenceAddress-Street', value: 'saleDate' },
      { field: 'CorrespondenceAddress-BuildingNumber', value: 'net23taxRate' },
      { field: 'CorrespondenceAddress-FlatNumber', value: 'vat23taxRate' },
      { field: 'CorrespondenceAddress-City', value: 'net8taxRate' },
      { field: 'CorrespondenceAddress-PostalCode', value: 'vat8taxRate' },
      { field: 'CorrespondenceAddress-Poczta', value: 'gross' },
      { field: 'CorrespondenceAddress-GLN', value: 'invoiceType' },
      { field: 'CorrespondenceForeignAddress-CountyCode', value: 'recordStatus' },
      { field: 'CorrespondenceForeignAddress-PostalCode', value: 'kseFNumber' },
      { field: 'CorrespondenceForeignAddress-City', value: 'systemInfo' },
      { field: 'CorrespondenceForeignAddress-Street', value: 'sellerFullName' },
      { field: 'CorrespondenceForeignAddress-BuildingNumber', value: 'sellerVATEUPrefix' },
      { field: 'CorrespondenceForeignAddress-FlatNumber', value: 'sellerTaxID' },
      { field: 'CorrespondenceForeignAddress-GLN', value: 'buyerFullName' },
      { field: 'Email', value: 'buyerVATEUPrefix' },
      { field: 'TelephoneNumber', value: 'buyerTaxID' },
      { field: 'RoleEntity', value: 'invoiceNumber' },
      { field: 'OtherRoleIndicator', value: 'documentCurrency' },
      { field: 'RoleDescription', value: 'documentDate' },
      { field: 'SharePercentage', value: 'saleDate' },
      { field: 'CustomerNumber', value: 'net23taxRate' },
    ];
    this.responseId = this.selectedRecords.responseId;
    this.recordStatus = this.selectedRecords.recordStatus;

    this.items = [
      {
        label: 'Header details',
        command: () => {
          this.activeItem2 = this.items[0];
        }
      },
      {
        label: 'Line Item details',
        command: () => {
          this.activeItem2 = this.items[1];
        }
      }
    ];

    this.activeItem2 = this.items[0];

    this.translate.onLangChange
      .pipe(
        startWith({ lang: this.translate.currentLang || this.translate.getDefaultLang() } as LangChangeEvent),
        takeUntilDestroyed(this.destroyRef))
      .subscribe((event: LangChangeEvent) => {
        this.lang = event.lang;
        this.setLabel();
      });

    this.fetchDashboardDetailData();
  }

  // fetchDashboardDetailData() {
  //   this.dataSourceValues = [];
  //   this.invoiceManagementService.fetchDashboardDetailData(this.responseId, this.recordStatus, this.lang, this.pageType)
  //     .pipe(takeUntilDestroyed(this.destroyRef))
  //     .subscribe({
  //       next: (response) => {
  //         if (response !== undefined && response !== null && response.length > 0) {
  //           this.dataSourceValues = Object.values(response[0]).map((value: any) => {
  //             value['command'] = () => {
  //               this.openTab(value.order);
  //             };
  //             return value;
  //           });
  //           for (let i = 0; i < this.dataSourceValues.length; i++) {
  //             if (this.dataSourceValues[i].value == 'Multiple') {
  //               let order = Number(this.dataSourceValues[i].order);
  //               if (this.dataSourceValues[i].attributes !== undefined) {
  //                 let headerTemp = Object.keys(this.dataSourceValues[i].attributes[0]);
  //                 this.headersMultiple[order] = headerTemp;
  //               }
  //             }
  //             if (this.dataSourceValues[i].value == 'Combination') {
  //               let order = Number(this.dataSourceValues[i].order);
  //               if (this.dataSourceValues[i].attributes !== undefined) {
  //                 let headerTemp = Object.keys(this.dataSourceValues[i].attributes[0]);
  //                 this.headersCombination[order] = headerTemp;
  //               }
  //             }
  //           }
  //           this.setLabel();
  //         }
  //       },
  //       error: (err) => {
  //         console.error(err);
  //       }
  //     });
  // }
  fetchDashboardDetailData() {
    this.dataSourceValues = [];
    this.invoiceManagementService.fetchDashboardDetailData(this.responseId, this.recordStatus, this.lang, this.pageType)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response) => {
          if (response !== undefined && response !== null && response.length > 0) {
            this.dataSourceValues = Object.values(response[0]).map((value: any) => {
              value['command'] = () => {
                this.openTab(value.order);
              };
              return value;
            });
  
            for (let i = 0; i < this.dataSourceValues.length; i++) {
              if (this.dataSourceValues[i].value === 'Multiple') {
                let order = Number(this.dataSourceValues[i].order);
                if (this.dataSourceValues[i].attributes !== undefined) {
                  let headerTemp = Object.keys(this.dataSourceValues[i].attributes[0]);
                  this.headersMultiple[order] = headerTemp;
                }
              }
  
              if (this.dataSourceValues[i].value === 'Combination') {
                let order = Number(this.dataSourceValues[i].order);
                if (this.dataSourceValues[i].attributes !== undefined) {
                  // Check if InvoiceNote (BT-22) is present
                  let combinedNotes = this.dataSourceValues[i].attributes
                  .map((attr: any) => {
                    let noteCode = attr["InvoiceNoteCode (BT-21)"];
                    let note = attr["InvoiceNote (BT-22)"];
                    console.log(noteCode, note);
                    let combinedNote = null;
                    
                    if (noteCode && note) {
                      combinedNote = `${noteCode}#${note}`;
                    } else if (noteCode) {
                      combinedNote = noteCode;
                    } else if (note) {
                      combinedNote = note;
                    }
                    console.log('notecode',combinedNote)

                    delete attr["InvoiceNoteCode (BT-21)"];
                    delete attr["InvoiceNote (BT-22)"];

                    return combinedNote;
                  })
                  .filter((note: string | null) => note !== null)
                  .join('\n'); // Combine with a new line
                  // Only add the combined notes if there are any notes
                  console.log(combinedNotes)
                  if (combinedNotes || combinedNotes=='' ) {
                    this.dataSourceValues[i].HeaderAttributes.push({
                      key: "InvoiceNoteCode (BT-21) and InvoiceNote (BT-22)",
                      value: combinedNotes
                    });
                  }
                this.dataSourceValues[i].attributes = this.dataSourceValues[i].attributes.filter((attr: any) => {
                  let precedingInvoiceNumber = attr["Preceeding Invoice Number (BT-25)"];
                  let precedingInvoiceDate = attr["Preceeding Invoice Date (BT-26)"];
                  
                  return precedingInvoiceNumber || precedingInvoiceDate;
                });
               console.log(this.dataSourceValues[i].HeaderAttributes)
               if (this.dataSourceValues[i].attributes.length > 0) {
                let headerTemp = Object.keys(this.dataSourceValues[i].attributes[0]);
                this.headersCombination[order] = headerTemp;
            }
                }
              }
            }
            this.setLabel();
            console.log(this.dataSourceValues);
          }
        },
        error: (err) => {
          console.error(err);
        }
      });
  }
  setLabel() {
    if (this.dataSourceValues && this.dataSourceValues.length > 0) {
      const translationKeys = [
        'text.addInfo',
        'text.general',
        'text.entity1',
        'text.entity2',
        'text.entity3',
        'text.authEntity',
        'text.docDetails',
        'text.invPeriod',
        'text.domSales',
        'text.domSales1',
        'text.domSales2',
        'text.annotations',
        'text.VATexemption',
        'text.transport',
        'text.VATmargin',
        'text.correction',
        'text.Entity1K',
        'text.Entity2K',
        'text.invLine',
        'text.debits',
        'text.deductions',
        'text.payment',
        'text.partialPayment',
        'text.paymentTerms',
        'text.bankAccount',
        'text.factorBankAccount',
        'text.transCon1',
        'text.transCon2',
        'text.transCon',
        'text.transDetails',
        'text.orderLine',
        'text.footer',
        'text.notDisplay',
        'text.error'
      ];

      this.translate.get(translationKeys).subscribe(res => {
        for (let i = 0; i < this.dataSourceValues.length; i++) {
          if (this.dataSourceValues[i].label == 'Additional Info') {
            this.dataSourceValues[i].label = res["text.addInfo"];
          } else if (this.dataSourceValues[i].label == 'General') {
            this.dataSourceValues[i].label = res["text.general"];
          } else if (this.dataSourceValues[i].label == 'Entity 1') {
            this.dataSourceValues[i].label = res["text.entity1"];
          } else if (this.dataSourceValues[i].label == 'Entity 2') {
            this.dataSourceValues[i].label = res["text.entity2"];
          } else if (this.dataSourceValues[i].label == 'Entity 3') {
            this.dataSourceValues[i].label = res["text.entity3"];
          } else if (this.dataSourceValues[i].label == 'Authorized Entity') {
            this.dataSourceValues[i].label = res["text.authEntity"];
          } else if (this.dataSourceValues[i].label == 'Document-Details') {
            this.dataSourceValues[i].label = res["text.docDetails"];
          } else if (this.dataSourceValues[i].label == 'Invoice period') {
            this.dataSourceValues[i].label = res["text.invPeriod"];
          } else if (this.dataSourceValues[i].label == 'Domestic sales - 23%') {
            this.dataSourceValues[i].label = res["text.domSales"];
          } else if (this.dataSourceValues[i].label == 'Domestic sales - 8%') {
            this.dataSourceValues[i].label = res["text.domSales1"];
          } else if (this.dataSourceValues[i].label == 'Domestic sales - 5%') {
            this.dataSourceValues[i].label = res["text.domSales2"];
          } else if (this.dataSourceValues[i].label == 'Annotations') {
            this.dataSourceValues[i].label = res["text.annotations"];
          } else if (this.dataSourceValues[i].label == 'VAT exemption') {
            this.dataSourceValues[i].label = res["text.VATexemption"];
          } else if (this.dataSourceValues[i].label == 'New means of transport') {
            this.dataSourceValues[i].label = res["text.transport"];
          } else if (this.dataSourceValues[i].label == 'VAT margin') {
            this.dataSourceValues[i].label = res["text.VATmargin"];
          } else if (this.dataSourceValues[i].label == 'Correction') {
            this.dataSourceValues[i].label = res["text.correction"];
          } else if (this.dataSourceValues[i].label == 'Entity 1K') {
            this.dataSourceValues[i].label = res["text.Entity1K"];
          } else if (this.dataSourceValues[i].label == 'Entity 2K') {
            this.dataSourceValues[i].label = res["text.Entity2K"];
          } else if (this.dataSourceValues[i].label == 'Invoice Line') {
            this.dataSourceValues[i].label = res["text.invLine"];
          } else if (this.dataSourceValues[i].label == 'Debits') {
            this.dataSourceValues[i].label = res["text.debits"];
          } else if (this.dataSourceValues[i].label == 'Deductions') {
            this.dataSourceValues[i].label = res["text.deductions"];
          } else if (this.dataSourceValues[i].label == 'Payment') {
            this.dataSourceValues[i].label = res["text.payment"];
          } else if (this.dataSourceValues[i].label == 'Partial Payment') {
            this.dataSourceValues[i].label = res["text.partialPayment"];
          } else if (this.dataSourceValues[i].label == 'Payment Terms') {
            this.dataSourceValues[i].label = res["text.paymentTerms"];
          } else if (this.dataSourceValues[i].label == 'Bank Account') {
            this.dataSourceValues[i].label = res["text.bankAccount"];
          } else if (this.dataSourceValues[i].label == 'Factor Bank Account') {
            this.dataSourceValues[i].label = res["text.factorBankAccount"];
          } else if (this.dataSourceValues[i].label == 'Discount') {
            this.dataSourceValues[i].label = res["text.discount"];
          } else if (this.dataSourceValues[i].label == 'Transaction Conditions-Agreements') {
            this.dataSourceValues[i].label = res["text.transCon1"];
          } else if (this.dataSourceValues[i].label == 'Transaction Conditions-Additional Information') {
            this.dataSourceValues[i].label = res["text.transCon2"];
          } else if (this.dataSourceValues[i].label == 'Transaction Conditions') {
            this.dataSourceValues[i].label = res["text.transCon"];
          } else if (this.dataSourceValues[i].label == 'Transportation Details') {
            this.dataSourceValues[i].label = res["text.transDetails"];
          } else if (this.dataSourceValues[i].label == 'Order Line') {
            this.dataSourceValues[i].label = res["text.orderLine"];
          } else if (this.dataSourceValues[i].label == 'Footer') {
            this.dataSourceValues[i].label = res["text.footer"];
          } else if (this.dataSourceValues[i].label == 'Not to be displayed') {
            this.dataSourceValues[i].label = res["text.notDisplay"];
          } else if (this.dataSourceValues[i].label == 'Error') {
            this.dataSourceValues[i].label = res["text.error"];
          }
        }
      });
    }
  }

  openTab(index: string) {
    this.viewportScroller.scrollToAnchor(index);
    this.selectedTab = index;
    if (this.selectedTab !== undefined && this.selectedTab !== this.previousSelectedTab) {
      document.getElementById(this.selectedTab).style.backgroundColor = "#747480";
      if (this.previousSelectedTab !== '0') {
        document.getElementById(this.previousSelectedTab).style.backgroundColor = "#ddd";
      }
      this.previousSelectedTab = this.selectedTab;
    }
  }

}

